import { resolveApiErrorMessage } from "./api-errors";

export function resolveToastMessage(message, type, i18nInstance) {
  if (typeof message === "string") {
    return message;
  }

  if (type === "error") {
    return resolveApiErrorMessage(message, i18nInstance);
  }

  return "";
}
